// debug-context.tsx
import React, { createContext, useContext, useEffect,useState } from 'react';

interface DebugContextType {
  isDebugEnabled: boolean;
  toggleDebug: (enabled: boolean) => void;
}

const DebugContext = createContext<DebugContextType | undefined>(undefined);

export function DebugProvider({ children }: { children: React.ReactNode }) {
  const [isDebugEnabled, setIsDebugEnabled] = useState(false);

  // Initialize from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('debug-enabled');
    if (stored) {
      setIsDebugEnabled(JSON.parse(stored));
    }
  }, []);

  const toggleDebug = (enabled: boolean) => {
    setIsDebugEnabled(enabled);
    localStorage.setItem('debug-enabled', JSON.stringify(enabled));
  };

  return (
    <DebugContext.Provider value={{ isDebugEnabled, toggleDebug }}>
      {children}
    </DebugContext.Provider>
  );
}

export function useDebug() {
  const context = useContext(DebugContext);
  if (context === undefined) {
    throw new Error('useDebug must be used within a DebugProvider');
  }
  return context;
}